import ACTIONS from '../actionTypes/lookupData'

const initialState = {
	allApiResources: [],
	allApplicationCategories: [],
	productPropertyFormats: [], // This data will change based on application category
	isFetchingProductPropertyFormats: false,
	allPlatforms: [],
	allProductStatuses: [],
	allProductTypes: [],
	allContractTypes: []
}

const lookupData = (state = initialState, action) => {
	switch (action.type) {

		// getAllApiResources
		case ACTIONS.GET_ALL_API_RESOURCES_SUCCESS:
			return {
				...state,
				allApiResources: action.payload,
			}

		// getAllApplicationCategories
		case ACTIONS.GET_ALL_APPLICATION_CATEGORIES_SUCCESS:
			return {
				...state,
				allApplicationCategories: action.payload,
			}

		// getProductPropertyFormats
		case ACTIONS.START_GET_PRODUCT_PROPERTY_FORMATS:
			return {
				...state,
				isFetchingProductPropertyFormats: true,
			}
		case ACTIONS.GET_PRODUCT_PROPERTY_FORMATS_SUCCESS:
			return {
				...state,
				productPropertyFormats: action.payload,
				isFetchingProductPropertyFormats: false,
			}
		case ACTIONS.GET_PRODUCT_PROPERTY_FORMATS_FAILED:
			return {
				...state,
			}

		// getAllPlatforms
		case ACTIONS.GET_ALL_PLATFORMS_SUCCESS:
			return {
				...state,
				allPlatforms: action.payload,
			}

		// getAllProductStatuses
		case ACTIONS.GET_ALL_PRODUCT_STATUSES_SUCCESS:
			return {
				...state,
				allProductStatuses: action.payload,
			}

		// getAllProductTypes
		case ACTIONS.GET_ALL_PRODUCT_TYPES_SUCCESS:
			return {
				...state,
				allProductTypes: action.payload,
			}
		// getAllContractTypes
		case ACTIONS.GET_ALL_CONTRACT_TYPES_SUCCESS:
			return {
				...state,
				allContractTypes: action.payload,
			}

		// default
		default:
			return state
	}
}

export default lookupData